// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"a60d873e","605":"4d9a37f0","809":"62452d41","981":"64758a87"}[chunkId] + ".chunk.js";
};